import { License, Software, LicensedSoftware } from '../ApiModel';
import { hasItem, orderBy, sum } from './ArrayHelper';
import { softwareGroups } from './SoftwareHelper';

export function applyLicenseGroupDefaults(licenses: License[], software: Software[]): License[] {
    const lics = licenses;
    const groups = softwareGroups(software);
    const result: License[] = [];

    // add 1 or 0 values for each software group
    for (const group of groups) {
        let hasSelection = false;
        for (const software of group.software) {
            const lic = lics.find((l) => l.software_id === software.id);
            if (lic) {
                result.push(lic);
                hasSelection = true;
                break;
            }
        }
        // if we are a multi item group, one value must be selected
        // with a default to the first value
        if (!hasSelection && hasItem(group.software) && group.software.length > 1) {
            result.push({ software_id: group.software[0].id, count: 1 });
        }
    }
    return orderBy(result, (l) => l.software_id);
}

export function licenseCountForSelectedSoftware(selections: License[], softwareId: number) {
    const lic = selections.find((l) => l.software_id === softwareId);
    if (!lic) return 0;
    return lic.count;
}

export function selectedSoftwareForSoftwareGroup(
    selections: License[],
    software: Software[],
    group: string
): Software | undefined {
    const selected = software.find((s) => s.group === group && licenseCountForSelectedSoftware(selections, s.id) > 0);
    return selected;
}

export function getLicenseCost(selections: License[], software: Software[]): number {
    return sum(
        selections,
        (l) => (software.find((s) => s.id === l.software_id)?.cost_per_licence_per_month ?? 0) * l.count
    );
}

export function asLicenses(licensedSoftware: LicensedSoftware[]): License[] {
    return licensedSoftware.map((l) => ({ software_id: l.software.id, count: l.licence_count }));
}
